import type { AxiosRequestConfig } from 'axios'
import merge from 'lodash.merge'

import type {
  Challenge,
  ChallengeId,
  ChallengeInitializer,
  ChallengeMutator,
} from '@beaded/models'

import * as apiUtils from '.'

const url = '/challenge'

export const create = (data: ChallengeInitializer): Promise<ChallengeId> =>
  apiUtils.POST(`${url}/`, data)

export const get = (id: ChallengeId, options: AxiosRequestConfig = {}) =>
  apiUtils.GET(`${url}/${id}`, merge({}, options))

export const getAll = (
  options: AxiosRequestConfig = {},
): Promise<{ challenges: Challenge[] }> =>
  apiUtils.GET(`${url}/`, merge({}, options))

export const update = (id: ChallengeId, data: ChallengeMutator) =>
  apiUtils.PUT(`${url}/${id}`, data)

export const remove = (id: ChallengeId) => apiUtils.DELETE(`${url}/${id}`)
